/* eslint-disable no-extra-boolean-cast */
/* eslint-disable prefer-template */
import { GET_MY, REQUEST_DATA_RESULT } from '../../containers/App/constants';
import {
  REQUEST_TRANSPORTER,
  REQUEST_TRANSPORTER_CREATE,
  REQUEST_TRANSPORTER_EDIT,
  REQUEST_TRANSPORTERS,
  REQUEST_DELETE_TRANSPORTER,
  SET_NEW_TRANSPORTER_VALUE,
  INITIATE_TRANSPORTER_EDIT,
  INITIATE_TRANSPORTER_CREATE,
  APPLY_TRANSPORTER_FILTERS,
  REQUEST_TRANSPORTER_FILTER,
  REQUEST_TRANSPORTER_FILTER_RESET,
  UPDATE_TRANSPORTER_FILTERS,
  UPDATE_TRANSPORTER_SEARCH_STRING,
  SET_TRANSPORTER_SORT,
  FILTER_DEFAULT_LIMIT,
} from './constants';
import { formatAmount, formatFinancialAmounts } from './helpers';

export function fetchTransporters(callback, limit = FILTER_DEFAULT_LIMIT) {
  return {
    type: GET_MY,
    id: REQUEST_TRANSPORTERS,
    post: { limit },
    work: REQUEST_TRANSPORTERS,
    gate: REQUEST_TRANSPORTERS,
    path: `transporters/getList`,
    callback,
  };
}

export function fetchTransporter(transporterId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_TRANSPORTER,
    transporterId,
    work: [REQUEST_TRANSPORTER, `${REQUEST_TRANSPORTER}-${transporterId}`],
    gate: REQUEST_TRANSPORTER + transporterId,
    path: `transporters/${transporterId}`,
    callback,
  };
}

export function editTransporter(id, dto, callback) {
  return {
    type: GET_MY,

    put: dto,
    work: REQUEST_TRANSPORTER_EDIT,
    gate: REQUEST_TRANSPORTER_EDIT,
    path: `transporters/${id}`,
    callback,
  };
}

export function deleteTransporter(transporterId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_DELETE_TRANSPORTER,
    gate: REQUEST_DELETE_TRANSPORTER + transporterId,
    delete: {},
    path: `transporters/${transporterId}`,
    putOnComplete: [fetchTransporters()],
    callback,
  };
}

export function initiateNewTransporterValue(name) {
  return {
    type: SET_NEW_TRANSPORTER_VALUE,
    name,
    initiate: true,
  };
}

export function initiateTransporterEdit(id) {
  return {
    type: INITIATE_TRANSPORTER_EDIT,
    id,
  };
}

export function initiateTransporterCreate() {
  return {
    type: INITIATE_TRANSPORTER_CREATE,
  };
}

export function applyTransporterFilters() {
  return {
    type: APPLY_TRANSPORTER_FILTERS,
  };
}

export function changeTransporterFilter(name, value) {
  return {
    type: REQUEST_TRANSPORTER_FILTER,
    name,
    value,
  };
}

export function setTransportersSort(sortType, order) {
  return {
    type: SET_TRANSPORTER_SORT,
    sortType,
    order,
  };
}

export function resetTransporterFilter() {
  return {
    type: REQUEST_TRANSPORTER_FILTER_RESET,
  };
}

export function updateTransporterFilter(propertyFilter, options) {
  return {
    type: UPDATE_TRANSPORTER_FILTERS,
    propertyFilter,
    ...options,
  };
}

export function updateWithFetchTransporterFilter(propertyFilter, options) {
  return {
    type: REQUEST_TRANSPORTER_FILTER,
    propertyFilter,
    options: {
      skipFilter: true,
    },
  };
}

export function updateSearchString(searchString) {
  return {
    type: UPDATE_TRANSPORTER_SEARCH_STRING,
    searchString,
  };
}

export function transportersSearch(text, callback) {
  let path = `transporters/getList`;

  const searchParams = {
    offset: 0,
    limit: 50,
    text,
    filters: [],
  };

  return {
    type: GET_MY,
    work: REQUEST_TRANSPORTERS,
    gate: REQUEST_TRANSPORTERS,
    path,
    post: searchParams,
    callback,
  };
}

export function changeTransporterPropertyFilter(propertyFilter, options) {
  return {
    type: REQUEST_TRANSPORTER_FILTER,
    propertyFilter,
    ...options,
  };
}

export function setNewTransporterValue(name, value) {
  return {
    type: SET_NEW_TRANSPORTER_VALUE,
    name,
    value,
  };
}

export function createTransporter(body, callback) {
  return {
    type: GET_MY,
    post: body,
    work: REQUEST_TRANSPORTER_CREATE,
    gate: REQUEST_TRANSPORTER_CREATE,
    path: `transporters`,
    callback,
  };
}
